// extracted by mini-css-extract-plugin
export default {"cls1":"Content-Header_cls1__8u-Jg","cls2":"Content-Header_cls2__kPi2u Content-Header_cls1__8u-Jg"};